import React, { useState } from "react";
import { connect } from "react-redux";
import Card from "components/card";
import ChooseCourseBoard from "./components/ChooseCourseBoard";
import SummaryHeader from "components/header/SummaryHeader";
import SummaryItem from "components/header/SummaryItem";
import EnrollmentSteps from "./components/EnrollmentSteps";
import SelectTeam from "./components/SelectTeam";
import { GraduationCap, LucideUsers, Sparkles, Target, TrendingUp } from "lucide-react";
import Users from "views/console/users";

const TeamUpskill = () => {

    const [selectedCourse, setSelectedCourse] = useState(null);
    const [selectedMembers, setSelectedMembers] = useState([]);

    const step1Done = !!selectedCourse;
    const step2Done = selectedMembers.length > 0;
    const step3Active = step1Done && step2Done;

const courses = [
  {
    id: 1,
    title: "Leadership & Management Skills",
    subtitle: "Develop essential leadership and team management capabilities",
    level: "Advanced",
    category: "Management",
    duration: "6 weeks",
    startDate: "Nov 22, 2025",
    instructor: "John Williams",
    enrolled: 10,
    capacity: 20,
  },
  {
    id: 2,
    title: "Advanced React & TypeScript",
    subtitle: "Master advanced React patterns and TypeScript integration",
    level: "Intermediate",
    category: "Development",
    duration: "8 weeks",
    startDate: "Nov 15, 2025",
    instructor: "Sarah Martinez",
    enrolled: 12,
    capacity: 25,
  },
  {
    id: 3,
    title: "Project Management Essentials",
    subtitle: "Learn to manage projects efficiently and effectively",
    level: "Beginner",
    category: "Management",
    duration: "4 weeks",
    startDate: "Dec 01, 2025",
    instructor: "David Kim",
    enrolled: 5,
    capacity: 15,
  },
];

    return (
        <div className="pt-6">
	    	<div className="grid grid-cols-1">
                <div className="space-y-6 ">
                    <SummaryHeader
                        title={"Upskill Your Team"}
                        icon={GraduationCap}
                        description={"Invest in growth. Empower your team with world-class training."}
                        color={"indigo"}
                        rightNav={
                                    step2Done && ( 
                                        <div className="flex flex-col items-center bg-white/20 border border-white/30 rounded-2xl p-4 min-w-[180px]">
                                        <Target size={32} className="mb-1" />
                                        <p className="text-[11px] text-purple-100">Selected for Enrollment</p>
                                        <p className="text-[24px] font-semibold text-white">
                                            {selectedMembers.length}
                                        </p>
                                        <p className="text-[11px] text-purple-200">
                                            {selectedMembers.length === 1 ? "team member" : "team members"}
                                        </p>
                                        </div>
                                    )
                                }
                    >
                        <div className="grid grid-cols-3 gap-4">
                            <SummaryItem
                                title="Available Courses"
                                icon={<Sparkles />}
                                display="6"
                            />
                            <SummaryItem
                                title="Team Members"
                                icon={<LucideUsers/>}
                                display="9" 
                            />
                            <SummaryItem
                                title="Total Enrollments"
                                icon={<TrendingUp/>}
                                display="79" 
                            />
                        </div>
                    </SummaryHeader>
                            
                    <EnrollmentSteps
                        step1Done={step1Done}
                        step2Done={step2Done}
                        step3Active={step3Active}
                        selectedCourse={selectedCourse}
                        selectedMembers={selectedMembers}
                    />
                     <Card extra="h-full">
                        <>
                        <div className="flex flex-col space-y-6">
                            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 gradient-icon">
                                <ChooseCourseBoard
                                    courses={courses}
                                    selectedCourse={selectedCourse}
                                    setSelectedCourse={setSelectedCourse}
                                    selectedMembers={selectedMembers}
                                    setSelectedMembers={setSelectedMembers}
                                />      
                                <div className="hidden lg:block">
                                <SelectTeam
                                    selectedMembers={selectedMembers}
                                    setSelectedMembers={setSelectedMembers}
                                />
                                </div>
                            </div>
                        </div>
                            
                        </>
                    </Card>

                </div>
            </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(TeamUpskill);